/* TODO: it is dummy function just to fill object with empty data - it will be later removed */

function defaultThumbnail() {
  return {
    id: `1`,
    name: ``,
    alternativeText: ``,
    caption: ``,
    width: 0,
    height: 0,
    formats: null,
    hash: ``,
    ext: ``,
    mime: ``,
    size: 0,
    url: `#`,
    previewUrl: `#`,
    provider: ``,
    related: ``,
    created_at: ``,
    updated_at: ``,
  };
}

export default defaultThumbnail;
